import React, { useRef } from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { useIsMobileDimension } from '@beef/ui-kit';
import { compose } from '@beef/utils';
import PropTypes from 'prop-types';
import { withAnalyticsOnBlockView } from "../hoc/withAnalyticsOnView";
import { useEffectOnlyOnce } from "../../hooks/useEffectOnlyOnce";
import { useInView } from "../../hooks/useInView";
import { onDevicesViewAnalitics } from "../../store/blocks/checkAddress/actions";
import { DEVICE_TAB_TYPE } from "../../store/blocks/constants";
import { getCurrentDevices, getDeviceBlockTitle } from "../../store/blocks/devices/selectors";
import { getAnalyticEventType } from "../../store/blocks/selectors";
import { FttbBlocks } from "../constants";
import { defineBlock } from "../utils";
import { CurrentDeviceContainer, DeviceBenefits, DeviceButtons, DeviceCard, DeviceCardContent, DeviceCardHeader, DeviceCardsMapper, DeviceDescription, DeviceDocumentation, DeviceHeading, DeviceIncludedIn, DeviceInfoPopup, DeviceModalTabs, DeviceParameters, DevicePrice, DeviceTitle } from "./components";
export var _DevicesBlock = function _DevicesBlock(_ref) {
  var className = _ref.className,
    onInit = _ref.onInit;
  var ref = useRef(null);
  var inView = useInView(ref, {
    threshold: 1
  });
  useEffectOnlyOnce(onInit, [inView], function (dependencies) {
    return !!dependencies[0];
  });
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: ref,
    "data-t-id": "blocks-DevicesBlock"
  }, /*#__PURE__*/React.createElement(DeviceHeading, {
    className: isMobile ? 'mar-b-s' : 'mar-b-m'
  }), /*#__PURE__*/React.createElement(DeviceCardsMapper, null, /*#__PURE__*/React.createElement(DeviceCardsMapper.Item, null, /*#__PURE__*/React.createElement(DeviceCard, null, /*#__PURE__*/React.createElement(DeviceCardHeader, {
    "data-t-id": "blocks-DevicesBlock"
  }), /*#__PURE__*/React.createElement(DeviceCardContent, null, /*#__PURE__*/React.createElement(DeviceTitle, {
    "data-t-id": "blocks-DevicesBlock"
  }), /*#__PURE__*/React.createElement(DeviceBenefits, null), /*#__PURE__*/React.createElement(DeviceIncludedIn, null)), /*#__PURE__*/React.createElement(DevicePrice, null), /*#__PURE__*/React.createElement(DeviceButtons, null)))), /*#__PURE__*/React.createElement(CurrentDeviceContainer, null, /*#__PURE__*/React.createElement(DeviceInfoPopup, {
    "data-t-id": "blocks-DevicesBlock"
  }, /*#__PURE__*/React.createElement(DeviceTitle, {
    "data-t-id": "blocks-DevicesBlock"
  }), /*#__PURE__*/React.createElement(DeviceModalTabs, null, /*#__PURE__*/React.createElement(DeviceModalTabs.Tab, {
    id: DEVICE_TAB_TYPE.deviceInformation
  }, /*#__PURE__*/React.createElement(DeviceDescription, null)), /*#__PURE__*/React.createElement(DeviceModalTabs.Tab, {
    id: DEVICE_TAB_TYPE.deviceParameters
  }, /*#__PURE__*/React.createElement(DeviceParameters, null)), /*#__PURE__*/React.createElement(DeviceModalTabs.Tab, {
    id: DEVICE_TAB_TYPE.deviceDocumentation
  }, /*#__PURE__*/React.createElement(DeviceDocumentation, null))))));
};
_DevicesBlock.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  onInit: PropTypes.func
} : {};
var mapStateToProps = function mapStateToProps(state) {
  var devices = getCurrentDevices(state);
  var titles = devices.map(function (_ref2) {
    var title = _ref2.title;
    return title;
  }).join(', ');
  return {
    analyticBlockTitle: getDeviceBlockTitle(state),
    devices: titles,
    pageType: getAnalyticEventType(state),
    shouldRender: !!devices.length
  };
};
var mapDispatchToProps = {
  onInit: onDevicesViewAnalitics
};
var _DeviceBlockHOC = withAnalyticsOnBlockView(_DevicesBlock);
export var DevicesBlock = compose(defineBlock(FttbBlocks.DEVICES), connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_DeviceBlockHOC);